import { useField, useFormikContext } from "formik";
import React from "react";
import styled from "styled-components";
import { Error } from "../Text";
import { colors } from "../Theme/colors";
import { Div } from "../utils";
export const useDisplayErrorMessage = (value) => {
    const { submitCount } = useFormikContext();
    if (value === null || submitCount === 0)
        return false;
    return true;
};
export const useFormikField = (name) => {
    const [field, meta, helpers] = useField(name);
    const { setValue, setTouched, setError } = helpers;
    const { error, touched } = meta;
    const shouldDisplayError = useDisplayErrorMessage(field.value);
    const hasError = shouldDisplayError && touched && error && error !== "";
    return {
        value: field.value,
        setValue,
        setTouched,
        setError,
        hasError,
        errorMsg: error,
    };
};
const FieldWrapper = styled(Div) `
  :focus {
    outline: none;
  }
`;
export const ErrorMessage = ({ msg }) => {
    return (React.createElement(Div, { mt: 10, dflex: true, alignCenter: true, c: colors.error },
        React.createElement(Error, null, msg)));
};
export const FormikField = ({ name, children, className = "", }) => {
    const { hasError, errorMsg } = useFormikField(name);
    return (React.createElement(FieldWrapper, { w100: true, name: name, tabIndex: 0, className: className },
        children,
        hasError && errorMsg && React.createElement(ErrorMessage, { msg: errorMsg })));
};
//# sourceMappingURL=fieldHelpers.js.map